import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'sma-web-app-error-page-robot',
  templateUrl: './app-error-page-robot.component.component.html',
  styleUrl: './app-error-page-robot.component.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AppErrorPageRobotComponentComponent {}
